/**
 * internal dependencies
 */
import { IPinPool } from '../../../../../models/cardgroup.interface';
import { COMMON_FORM_ELEMENTS, PIN_POOL_ACTIONS } from '../utils/pin-pool-types';
import { debounce } from '../utils/debounce';
import { checkForUniquePin } from '../utils/unique-pins';

import PostPinPool from '../../../../../routes/post-pin-pool';
import { showToast } from '../../../../toasts';

/**
 * Function to handle adding a pin pool record.  This function will 
 * handle both adding a new pin pool and adding a pin to an existing 
 * pool depending on the hasPinPool value in the data passed to it.
 * 
 * @param data Pin Pool data from api
 */
export const addPinPool = (data: IPinPool, askFor: number) => {
  const { cardGroup, pinPool: { hasPinPool, pins } } = data.body;
  const { cardGroupId } = cardGroup;
  const { ceAddPinForm, ceSubmitButton, cePinNumberInput, cePinDescriptionInput, ceError } = COMMON_FORM_ELEMENTS;

  const validateForm = () => {
    ceAddPinForm.classList.add('was-validated');

    if (!ceAddPinForm.checkValidity()) {
      throw new Error('Form is not valid');
    }

    return true;
  };

  cePinNumberInput.addEventListener('keyup', () => debounce(() => checkForUniquePin(pins), 700)());

  ceAddPinForm.addEventListener('submit', async event => {
    event.preventDefault();
    event.stopPropagation();

    const pinData = cePinNumberInput.value.trim();
    const descriptionData = cePinDescriptionInput.value.trim();

    try {
      validateForm();
      ceAddPinForm.classList.remove('form-control:valid');
      ceSubmitButton.classList.add('aafp_button-loading');
      cePinNumberInput.classList.remove('invalid-pins');
      ceError.textContent = '';  

      const awsData = {
        cardGroupId: cardGroupId!,
        askFor,
        pin: pinData,
        pinDescription: descriptionData,
        action: hasPinPool ? PIN_POOL_ACTIONS.ADDPIN : PIN_POOL_ACTIONS.ADDPOOL
      }
   
      const { statusCode } = await PostPinPool(awsData);
      if ( statusCode === 200 ) {
        showToast('aafp_toast', `${askFor === 1 ? 'Pin' : 'Vehicle'} Pool has been updated`);
        setTimeout(() => {
          location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error('Error validating form', error);
    } finally {
      ceSubmitButton.classList.remove('aafp_button-loading');
    }
  }, { once: true });
};